import { render, staticRenderFns } from "./BaseTextarea.vue?vue&type=template&id=4945efd2&scoped=true&"
import script from "./BaseTextarea.vue?vue&type=script&lang=js&"
export * from "./BaseTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4945efd2",
  null
  
)

export default component.exports